import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MESSAGES } from '../../constants/message';

@Component({
  selector: 'app-modal-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],
  templateUrl: './modal-dialog.component.html',
  styleUrl: './modal-dialog.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ModalDialogComponent {
  public action: string = '';
  public msg = MESSAGES;
  public save = 'save';
  public proceed = 'proceed';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.action = data.dialogData.action
  }

}
